<template>
    <div id="verification">
        <div class="container m_t">
            <div class="center_title">
                <Title :en="Text.en" chtFirst="驗證" :chtSecond="Text.chtSecond" :center="true"></Title>
            </div>
            <section class="content">
                <div class="text" v-html="Text.Html"></div>
                <div class="btn_box">
                    <div class="Orange_btn islogin">
                        <a href="javascript:;" v-if="!verification" @click="SendEmail">重寄認證信</a>
                        <a
                            href="javascript:;"
                            v-if="verification"
                            @click="Login"
                        >{{IsLogin ? "填寫會員資料" : "會員登入"}}</a>
                    </div>
                </div>
            </section>
            <graybtn />
        </div>
    </div>
</template>

<script>
import API from "@/service/member";
export default {
    name: "verification",
    components: {},
    props: {
        verification: {
            type: Boolean
        }
    },
    data() {
        return {
            IsLogin: false
        };
    },
    methods: {
        SendEmail() {
            const vm = this;
            API.getSendEmail(res => {
                if (res.Ok) {
                    vm.$swal({
                        type: "success",
                        text: "寄信成功，請至您的信箱收取信件。",
                        confirmButtonText: "確定"
                    });
                } else {
                    vm.$swal({
                        type: "fail",
                        text: "寄信失敗，請稍後在試。",
                        confirmButtonText: "確定"
                    });
                }
            });
        },
        Login() {
            const vm = this;
            if (vm.IsLogin) {
                location.href = "/Member";
            } else {
                let Loginbox = document.getElementById("loginbox");
                let tops = $(document).scrollTop();
                $(document).bind("scroll", function() {
                    $(document).scrollTop(tops);
                });
                Loginbox.style.display = "flex";
            }
        }
    },
    computed: {
        Text() {
            let Obj = {};
            if (this.verification) {
                Obj = {
                    en: "Verification Success",
                    chtSecond: "成功",
                    Html: `<p>帳號啟動成功</p><p>請至會員中心填寫資料</p>
          `
                };
                return Obj;
            } else {
                Obj = {
                    en: "Verification Fail",
                    chtSecond: "失敗",
                    Html: `<p>帳號啟動失敗</p><p>接下來請登入並到會員權限頁面重新寄驗證信</p>
          `
                };
                return Obj;
            }
        }
    },
    created() {
        const vm = this;
        let veriff = localStorage.getItem("veriff");
        if (veriff != null) {
            vm.IsLogin = true;
        } else {
            vm.IsLogin = false;
        }
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#verification .content {
    border: 8px solid #eee;
    padding: 20px;
    color: #666;
    letter-spacing: 2px;
    line-height: 1.5;
}
#verification .content .text {
    text-align: center;
}
#verification .content .text >>> p {
    margin-bottom: 15px;
}
#verification .content .btn_box {
    width: 165px;
    margin: 30px auto 30px;
}
@media screen and (max-width: 767px) {
    /* Step 01 */
    #verification .content {
        padding: 20px 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/verification.vue